export enum SearchParams {
	Zoom = 'zoom',
	Lat = 'lat',
	Lng = 'lng',
	Page = 'page',
	GroupBy = 'groupBy',
	EntityIds = 'entityIds',
	Timeframe = 'timeframe',
	YachtTrack = 'yacht-track',
	IsActive = 'is_active',
	BoatId = 'boat_id',
}
